module.exports = __webpack_public_path__ + "static/img/larr.f590225.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/larr.svg
// module id = CMZO
// module chunks = 1